/**
 * Converts an object to a URL-encoded query string.
 *
 * This function takes an object, filters out entries with undefined values,
 * and converts the remaining entries into a URL-encoded query string.
 *
 * @param input - The input object to convert.
 * @returns A URL-encoded query string representing the object.
 *
 * @example
 * // returns "name=John&age=30"
 * toQueryString({ name: 'John', age: 30 });
 *
 * // ignores undefined values
 * // returns "name=John"
 * toQueryString({ name: 'John', age: undefined });
 */
export default function (input: object) {
  return Object.entries(input)
    .filter(([_, value]) => value !== undefined) // Remove entries with undefined values
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&')
}
